import { render, staticRenderFns } from "./ActionRequiredInfo.vue?vue&type=template&id=4e499abb&"
import script from "./ActionRequiredInfo.vue?vue&type=script&lang=ts&"
export * from "./ActionRequiredInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports